module.exports = __webpack_public_path__ + "img/Event_Location.28245b7e.png";